const colorPallete = {
  primary: '#245AD3',
  accent: '#A41E39',
  primaryDark: '#0EA3DB',
  accentDark: '#DB3D5D'
};

export { colorPallete };
